import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import {
  isFeatureRestrictedForAccount,
  resolveRestrictedFeatureFromPath,
} from '../helper/restrictedFeatures';

const routes = [...dashboard.routes];
const loadedAccountIds = new Set();

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'no_accounts' || !to.name) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  const currentAccount = store.getters['accounts/getAccount'](
    Number(to.params?.accountId)
  );
  const targetAccountId = Number(to.params?.accountId || accountId);
  const restrictedFeature = resolveRestrictedFeatureFromPath(to.path);
  const currentRole = store.getters.getCurrentRole;
  const isFeatureRestricted = isFeatureRestrictedForAccount(
    currentAccount,
    restrictedFeature,
    {
      surface: 'frontend',
      currentUser: user,
      currentRole,
    }
  );

  if (restrictedFeature && isFeatureRestricted && to.name !== 'home') {
    return next(frontendURL(`accounts/${targetAccountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(async () => {
      const accountId = Number(to.params?.accountId || 0);
      if (accountId && !loadedAccountIds.has(accountId)) {
        try {
          await store.dispatch('accounts/get');
          loadedAccountIds.add(accountId);
        } catch (error) {
          // Ignore account fetch errors in guard; existing auth checks handle redirects.
        }
      }

      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
